import { classNames } from 'shared/lib/classNames/classNames';
import { Buttons } from 'features/StepActions/ui/Buttons';
import { useSelector } from 'react-redux';
import { getPlotStepData } from 'widgets/PlotSteps';
import cls from './QuestionView.module.scss';

interface QuestionViewProps {
    className?: string
}
export const QuestionView = (props: QuestionViewProps) => {
    const {
        className,
    } = props;
    const stepData = useSelector(getPlotStepData);

    return (
        <div className={classNames(cls.QuestionView, {}, [className])}>
            <div className={cls.question}>
                {stepData?.action?.questionView?.question}
            </div>
            <Buttons />
        </div>
    );
};
